import { obterNomeCacheRequerimentoTO } from "../onboarding/helper";

const INITIAL_STATE = {
  esperandoSolicitacao: false,
  alerta: {},
  atestado: null,
};

const MESSAGE_CONNECTION = 'Não foi possível se comunicar com nossos servidores, tente novamente mais tarde.';
export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case 'REQUERIMENTO_DADOS_PEDIDO_VALIDAR_DADOS_CIDADAO_INICIAR':
      return { ...state, alerta: {}, esperandoSolicitacao: true };
    case 'REQUERIMENTO_DADOS_PEDIDO_VALIDAR_CONCLUSAO_PREENCHIMENTO_SUCESSO':
    case 'REQUERIMENTO_DADOS_PEDIDO_VALIDAR_DADOS_CIDADAO_SUCESSO':
      return { ...state, esperandoSolicitacao: false }
    case 'REQUERIMENTO_DADOS_PEDIDO_VALIDAR_DADOS_GRUPO_SUCESSO':
      let requerimentoCache = JSON.parse(localStorage.getItem(obterNomeCacheRequerimentoTO()));
      if (requerimentoCache && (action.payload?.dadosAdicionais?.length || action.payload?.anexos?.length)) {
        const novoRequerimentoCache = { ...requerimentoCache, dadosAdicionais: action.payload?.dadosAdicionais, anexos: action.payload?.anexos }
        localStorage.setItem(obterNomeCacheRequerimentoTO(), JSON.stringify(novoRequerimentoCache));
      }
      return { ...state, esperandoSolicitacao: false }
    case 'REQUERIMENTO_DADOS_PEDIDO_VALIDAR_DADOS_CIDADAO_ERROR':
      return { ...state, esperandoSolicitacao: false, alerta: { message: MESSAGE_CONNECTION, severity: 'error' } }
    case 'REQUERIMENTO_DADOS_PEDIDO_VALIDAR_DADOS_GRUPO_ERROR':
    case 'REQUERIMENTO_DADOS_PEDIDO_VALIDAR_CONCLUSAO_PREENCHIMENTO_ERROR':
      return { ...state, esperandoSolicitacao: false, alerta: { message: action.payload, severity: 'error' } }
    case 'REQUERIMENTO_DADOS_PEDIDO_CLOSE_MESSAGE':
      return { ...state, alerta: {} };
    case 'REQUERIMENTO_DADOS_PEDIDO_ALERTA_VALIDACAO_ERROR':
      return { ...state, alerta: action.payload };
    default:
      return state;
  }
}
